import { render, staticRenderFns } from "./ModalAutorizada.vue?vue&type=template&id=7d7134e0&scoped=true"
import script from "./ModalAutorizada.vue?vue&type=script&lang=ts"
export * from "./ModalAutorizada.vue?vue&type=script&lang=ts"
import style0 from "./ModalAutorizada.vue?vue&type=style&index=0&id=7d7134e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7134e0",
  null
  
)

export default component.exports